/**
 * <strong>Properties:</strong><br>
 * <br>
 * <li>{@link module:mw-form/mixins/property/DescriptionMixin|description}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/DisabledMixin|disabled}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/EditableMixin|editable}</li>
 * <br>
 * <li>items</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/PlaceholderMixin|placeholder}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/TagMixin|tag}</li>
 * <br>
 * <li>text</li>
 * <br>
 * <li>value</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/ValidationMixin|validationState, errorText, warningText}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/SizeMixin|width, height}</li>
 * <br>
 * <br>
 * <strong>Events:</strong>
 * <br>
 * <br>
 * <li>{@link module:mw-form/mixins/event/ChangeEventMixin|change}</li>
 * <br>
 * <br>
 * <strong>Example:</strong>
 * <br>
 * <br>
 * For a working example, see the {@link http://inside-files/dev/eps/WIT/WebWidgets/Gallery/Gallery/|gallery}
 * <br>
 * <br>
 * @module mw-form/ComboBox
 *
 * @copyright Copyright 2015-2018 The MathWorks, Inc.
 */

// TODO: Remove _CSSStateMixin dependency, as seen in SplitButton and ToggleSplitButton

define([
  'dojo/_base/declare',
  'dojo/on',
  'dojo/has',
  'dojo/keys',
  'dijit/popup',
  'dijit/_WidgetBase',
  'dijit/_Contained',
  'dijit/_CssStateMixin',
  'dijit/_FocusMixin',
  'dijit/_TemplatedMixin',
  'dijit/focus',
  'dojo/mouse',
  'mw-form/mixins/AccessibilityClickMixin',
  'mw-form/mixins/property/TagMixin',
  'mw-form/mixins/property/DisabledMixin',
  'mw-form/mixins/property/EditableMixin',
  'mw-form/mixins/property/DescriptionMixin',
  'mw-form/mixins/property/SizeMixin',
  'mw-form/mixins/property/TextInputValueMixin',
  'mw-form/mixins/property/VisualFamilyMixin',
  'mw-form/mixins/ResizeMixin',
  'mw-form/mixins/property/ValidationMixin',

  'mw-form/mixins/event/ChangeEventMixin',

  'mw-form/TextField',
  'dijit/_Container',
  'mw-form/mixins/KeyNavMixin',
  'mw-dom-utils/domUtils',
  'mw-form/mixins/mixinDependencyValidator',

  'dojo/text!./templates/ComboBox.html'

], function (declare, on, has, keys, popup, _WidgetBase, _Contained, _CssStateMixin,
  _FocusMixin, _TemplatedMixin, focusUtil, mouse, AccessibilityClickMixin, TagMixin, DisabledMixin, EditableMixin, DescriptionMixin,
  SizeMixin, TextInputValueMixin, VisualFamilyMixin, ResizeMixin,
  ValidationMixin, ChangeEventMixin, TextField, _Container, KeyNavMixin, domUtils, mixinDependencyValidator, ComboBoxTemplate) {
  var ComboBoxMenu = declare([_WidgetBase, _TemplatedMixin, _CssStateMixin,
    _Container, KeyNavMixin, VisualFamilyMixin], {
    baseClass: 'mwWidget mwComboBoxPopup',
    templateString: '<div tabindex="0"><div data-dojo-attach-point="menuItemsNode"></div></div>',

    // Returns all Menu items DOM nodes in the menu
    getChildren: function () {
      var childNodes = Array.prototype.slice.call(this.menuItemsNode.childNodes);
      return childNodes;
    }
  });

  return declare(mixinDependencyValidator.validate([_WidgetBase, _Contained, _CssStateMixin, _FocusMixin,
    _TemplatedMixin, AccessibilityClickMixin, TagMixin, DisabledMixin, EditableMixin, DescriptionMixin, SizeMixin,
    TextInputValueMixin, VisualFamilyMixin, ResizeMixin, ValidationMixin, ChangeEventMixin]), {

    baseClass: 'mwWidget mwComboBox',
    templateString: ComboBoxTemplate,
    editable: false,
    text: '',
    // Overriding value of size mixin
    height: 22,
    width: 150,
    maxHeight: 500,
    ORIENTATION_VALUES: {
      'below': ['below', 'below-alt'],
      'vertical': ['below', 'below-alt', 'above', 'above-alt'],
      'horizontal': ['after', 'before']
    },
    closeOnWindowResize: true,

    // If blurAfterSelection is true, blur the ComboBox after a dropdown item is selected,
    // otherwise set focus to the focusNode.
    blurAfterSelection: false,

    _boundWindowResizeHandler: null,
    _boundWindowScrollHandler: null,

    constructor: function (args) {
      args = args || {};

      // By default set the newly created textfield to be non-editable
      // and also disabled.

      this._textField = new TextField({
        editable: false,
        disabled: true
      });

      this.own(this._textField);

      this.own(
        on(this._textField, 'typing', this._handleTextFieldTyping.bind(this)),
        on(this._textField, 'keydown', this._handleTextFieldKeyDown.bind(this)),
        on(this._textField, 'keyup', this._handleTextFieldKeyUp.bind(this))
      );

      this.menu = new ComboBoxMenu({
      });
      this.own(this.get('menu'));

      this.menu.onOpen = function() {
        // Called from ComboBoxMenu onOpen
        // Any previous listener will have been removed by onClose before new onOpen occurs
        window.addEventListener('scroll', this._boundWindowScrollHandler, true);
      }.bind(this);
      
      this.menu.onClose = function() {
          // Called from ComboBoxMenu onClose
          window.removeEventListener('scroll', this._boundWindowScrollHandler, true);
      }.bind(this);

      // boolean to keep track of empty text property
      this._isTextEmpty = true;

      this._pendingValue = null;

      if (args) {
        if (this.get('editable') === false && args.value && !args.items) {
          throw new Error('Value cannot be set on a non-editable combo box without having items');
        }
      }

      this._boundWindowResizeHandler = this._handleWindowResize.bind(this);
      this._boundWindowScrollHandler = this._handleWindowScroll.bind(this);
    },

    postCreate: function () {
      this.inherited(arguments);
      
      this.own(
        // Click to give text field focus
        on(this.domNode, 'mousedown', this.focus.bind(this)),
        // Detect it clicked inside combobox or not and close menu
        on(this._textField.inputNode, 'blur', this._handleTextFieldBlur.bind(this), true),
        on(this.domNode, 'blur', this._handleDomNodeBlur.bind(this), true),
        on(this.domNode, 'keydown', this._handleDomNodeKeyDown.bind(this)),
        on(this.menu.menuItemsNode, 'click', this._handleMenuClick.bind(this)),
        on(this.menu.menuItemsNode, 'keydown', this._handleMenuKeyDown.bind(this)),
        on(this._textField, 'mouseover', this._handleTextFieldMouseover.bind(this)),
        on(this._textField, 'change', this._handleTextFieldChange.bind(this), true)
      );

      if (!this._menuNodeMouseDownHandler) {
        this._menuNodeMouseDownHandler = this._handleArrowNodeMouseDown.bind(this);
        this.menuNode.addEventListener('mousedown', this._menuNodeMouseDownHandler);
      }

      // the _menuNodeMouseDownHandler needs to be removed for a disabled widget
      if (this.get('disabled') === true) {
        this.menuNode.removeEventListener('mousedown', this._menuNodeMouseDownHandler);
        this._menuNodeMouseDownHandler = null;
      }

      this.menu.domNode.addEventListener('blur', this._handleMenuBlur.bind(this), true);

      // g1721748: The resize listener on ComboBox caused the menu to close in Simulink when the embedded
      // rendering frame resized, meaning if the ComboBox menu opened, this resized the Simulink rendering
      // frame, and in turn caused the menu to close.
      window.addEventListener('resize', this._boundWindowResizeHandler, true);

      // If the items array is supplied as an argument assign it to _items otherwise
      // create a dummy array of items.
      if (this.get('items') === undefined || this.get('items').length === 0) {
        this.set('items', []);
      }
      // set menuOrientation to vertical by default
      this.set('menuOrientation', 'vertical');
    },

    _handleWindowResize: function () {
      if ((this.closeOnWindowResize === true) && (this._comboBoxMenuOpened === true)) {
        this.closeMenu();
      }
    },

    _handleWindowScroll: function (evt) {
      // Close ComboBox if the user scrolls any container of the ComboBox.
      // But don't close if the ComboBox menu itself is being scrolled, or if the
      // ComboBox is active. In the latter case, a minor scroll-into-view may be 
      // occurring on the ComboBox, so it's okay to leave the menu open.
      if (this._comboBoxMenuOpened && evt.srcElement !== this.menu.domNode.parentElement && !this.active) {
        // Check to see whether the scroll event source element contains this ComboBox. 
        // If something unrelated is being scrolled, don't close the menu. Otherwise the menu
        // won't stay open if, say, log data is streaming to and scrolling a console pane.
        var comboBoxContainerScrolled = (evt.srcElement === document); // entire document was scrolled

        // Special case (see g2137707 and g2074729) -- if the user mouses over a partially visible menu item, then IF 
        // that menu item is at the top or bottom of the browser window, the browser will generate a scroll event with
        // srcElement set to the document (rather than the menu parentElement). DON'T close the menu in this case.
        if (comboBoxContainerScrolled && document.activeElement && document.activeElement.classList.contains('mwMenuItem')) {
          // Check if that menu item is at the top or bottom of the window
          var menuItemRect = document.activeElement.getBoundingClientRect();
          if ((Math.abs(window.innerHeight - menuItemRect.bottom) <= menuItemRect.height)
            || (Math.abs(menuItemRect.top) <= menuItemRect.height)) {
            comboBoxContainerScrolled = false;
          }
        }

        if (!comboBoxContainerScrolled) {
          var node = this.domNode;
          while (node !== null) {
            if (node === evt.srcElement) {
              comboBoxContainerScrolled = true;
              break;
            }
            node = node.parentElement;
          }
        }
        if (comboBoxContainerScrolled) {
          this.closeMenu();
        }
      }
    },

    // TODO: move to CloseOnWindowResizeMixin.js
    _setCloseOnWindowResizeAttr: function (value) {
      if (typeof value !== 'boolean') {
        throw new Error("Input value expected to be of type 'boolean'.");
      }

      this._set('closeOnWindowResize', value);
    },

    startup: function () {
      this.inherited(arguments);

      // Calling the resize() method to compute and
      // adjust the width of textfield and arrow node with respect
      // to the width of the combo box.
      this.menu.startup();
      this._textField.startup();

      if (!this._isResized) {
        this.resize();
      }
    },

    destroy: function () {
      window.removeEventListener('resize', this._boundWindowResizeHandler, true);
      window.removeEventListener('scroll', this._boundWindowScrollHandler, true);
      this._boundWindowResizeHandler = null;
      this._boundWindowScrollHandler = null;
      this.inherited(arguments);
    },

    buildRendering: function () {
      this.inherited(arguments);

      this._textField.placeAt(this.textFieldContainerNode);

      this.inputNode = this._textField.inputNode;
      // assign domNode of the widget to be the focus node by default
      this.focusNode = this.domNode;
    },

    // dom is descendant

    _isDescendant: function (parent, child) {
      // Clicking on scrollbar
      if (parent === child) {
        return true;
      }
      var node = child.parentNode;
      while (node != null) {
        if (node === parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    },

    // Toggle opening and closing menu
    _handleArrowNodeMouseDown: function (e) {
      // TODO; do opposite
      if (this._comboBoxMenuOpened !== true) {
        if (e.button === 0) {
          this._openComboBoxMenu();
        }
      } else {
        this.closeMenu();
      }
    },

    // Helper function that will be called in multiple places to close menu

    closeMenu: function (blurOnClose) {
      // If TAB'ing through or clicking away, closeMenu should NOT keep focus
      if ((!this.get('blurAfterSelection')) && !blurOnClose) {
        focusUtil.focus(this.focusNode);
      } else {
        // Firefox does not blur - explicitly emit blur event
        if (has('ff')) {
          if (this._isDescendant(this.menu.domNode, document.activeElement)) {
            document.activeElement.blur();
          }
        }
      }
      popup.close(this.get('menu'));
    },

    _closeMenuOnBlur: function (e) {
      setTimeout(function () {
        if (!this._isDescendant(this.domNode, document.activeElement) &&
                                !this._isDescendant(this.menu.domNode, document.activeElement)) {
          if (this._comboBoxMenuOpened) {
            this.closeMenu(true);
          }

          var oldValue = this.get('value');

          // Value needs to be committed here. See g1394989
          var selected = this._getSelectedItemFromLabel(oldValue);
          if (!selected) {
            selected = { label: '', value: '' };
          }

          if (this.get('editable') === true && // if the combobox is editable
                this.inputNode.value !== '' && // and text in textfield is not ""
                this.inputNode.value !== selected.label && // and if there is a change/difference between typed and existing label
                this.inputNode.value !== this.get('value')) { // and if the text is not same as the existing value
            // commit the value
            selected = this._getSelectedItemFromLabel(this.inputNode.value);
            if (selected && selected.index !== undefined) { // if text is an existing label in items then get the value and set it
              this.set('value', selected.value);
            } else { // if text is a non-existing item then get the value and set it
              this.set('value', this.inputNode.value);
            }

            // set the value to be "" only when the existing value is not ""
          } else if (this.inputNode.value === '' && this.get('value') !== '' && this.get('editable') === true) {
            this.set('value', '');
          }

          var newValue = this.get('value');
          if (oldValue !== newValue) {
            this._triggerChangeEvent('value', oldValue, newValue);
          }
        }
      }.bind(this), 0);
    },

    _handleMenuBlur: function (e) {
      this._closeMenuOnBlur(e);
    },

    _handleMenuItemMouseEnter: function (e) {
      if (domUtils.isFocusable(e.target)) {
        focusUtil.focus(e.target);
      }
    },

    // TODO: try removing if and call one method from listeners
    _handleTextFieldBlur: function (e) {
      // When clicked outside of TextField without hovering on menu
      // When clicked on another combobox
      // When clicked on body
      if (this.get('editable') === true) {
        this._closeMenuOnBlur(e);
      }
    },

    _handleTextFieldMouseover: function (e) {
      // if focus is in the dropdown and then the user moves the mouse back over the text field,
      // then switch focus back to the text field (or domNode, if non-editable)
      if ((!this.get('disabled')) && this._isDescendant(this.menu.domNode, document.activeElement)) {
        focusUtil.focus(this.focusNode);
      }
    },

    _handleTextFieldChange: function (e) {
      // Change events are managed by ComboBox. Suppress the change event that is
      // emitted by the SharedTextInputMixin (which TextField extends).
      e.stopPropagation();
      e.preventDefault();
    },

    _handleDomNodeBlur: function (e) {
      if (this.get('editable') === false) {
        this._closeMenuOnBlur(e);
      }
    },

    // Focus and Highlight selected menu item
    _handleUpAndDownArrow: function (e) {
      var menuItems = this.get('menu').getChildren();
      var selected = this._get('value') !== undefined ? this._getSelectedItemFromValue(this._get('value')) : undefined;
      var start, i;

      if (e.keyCode === keys.DOWN_ARROW) {
        // the start index should begin from the next index of current selected item or 0 if there is no selected item
        start = selected && selected.index !== undefined ? selected.index % menuItems.length : 0;
        for (i = start; i < menuItems.length; i++) {
          if (this._isKeyboardNav(menuItems[i])) { // skip hidden menuItems and separators
            focusUtil.focus(menuItems[i]);
            break;
          }
        }
        if (!this._comboBoxMenuOpened) {
          this._openComboBoxMenu();
        }
        e.preventDefault();
      } else if (e.keyCode === keys.UP_ARROW) {
        // the start index should begin from the previous index of current selected item or last index if there is no selected item
        start = selected && selected.index !== undefined ? selected.index % menuItems.length : menuItems.length - 1;
        for (i = start; i >= 0; i--) {
          if (this._isKeyboardNav(menuItems[i])) { // skip hidden menuItems and separators
            focusUtil.focus(menuItems[i]);
            break;
          }
        }
        if (!this._comboBoxMenuOpened) {
          this._openComboBoxMenu();
        }
        e.preventDefault();
      }
    },

    _handleDomNodeKeyDown: function (e) {
      // handle only if it is editable and non-disabled
      if (this.get('editable') === false && !this.get('disabled') === true) {
        this._handleUpAndDownArrow(e);
        if (e.keyCode === keys.SPACE || e.keyCode === keys.ENTER) {
          if (this._comboBoxMenuOpened !== true) {
            this._openComboBoxMenu();
          } else {
            this.closeMenu();
          }
          // Prevent scrolling of page
          e.stopPropagation();
          e.preventDefault();
        }
      }
      if (e.keyCode === keys.ESCAPE) {
        if (this._comboBoxMenuOpened === true) {
          e.stopPropagation();
          e.preventDefault();
        }
        // close the drop down on pressing escape
        this.closeMenu();
      }
    },

    /*
     * Overriding the disabled property setter from DisabledMixin.
     * */

    _setDisabledAttr: function (disabled) {
      this.inherited(arguments);
      // When disabled property is true we need to remove the _menuNodeMouseDownHandler if present
      if (disabled === true) {
        this._removeMenuNodeMouseDownHandler();

        if (this._comboBoxMenuOpened) {
          this.closeMenu();
        }
        // When disabled property is false we need to add the _menuNodeMouseDownHandler back
      } else {
        this._addMenuNodeMouseDownHandler();
      }

      if (this.get('editable') === true) {
        this._textField.set('disabled', disabled);
      }

      // Make sure that at most one element in the ComboBox has tabIndex set at a time
      if (disabled) {
        this.domNode.removeAttribute('tabIndex');
        this._textField.focusNode.removeAttribute('tabIndex');
      } else {
        // if re-enabling a ComboBox, put the domNode or text field focusNode back in the TAB order
        if (this.get('editable')) {
          this.domNode.removeAttribute('tabIndex');
          this._textField.focusNode.setAttribute('tabIndex', '0'); // see g1438764
        } else {
          this._textField.focusNode.removeAttribute('tabIndex');
          this.domNode.setAttribute('tabIndex', '0');
        }
      }
    },

    /*
     * This method handles the Key Down event that is fired
     * on the text field. The method loops through menu items to find the next
     * menu item that is visible to give focus to it.
     *
     * Pressing ESCAPE key will close the dropdown and cancel the commit.
     * */

    _handleTextFieldKeyDown: function (e) {
      this._gotTextFieldKeyDownForEnterOrSpace = (e.keyCode === keys.ENTER || e.keyCode === keys.SPACE) && !this.get('disabled');  // see _handleTextFieldKeyUp
      
      if (this.get('editable') === true) {
        this._handleUpAndDownArrow(e);
      }

      if (this.get('editable') === true && e.keyCode === keys.ENTER) {
        var enteredText = this.inputNode.value;
        this._isTextEmpty = true; // this flag is needed to keep track of empty text value
        // if the typed value is an existing item, set the value of the corresponding item
        var selected = this._getSelectedItemFromLabel(enteredText);

        var oldValue = this.get('value');

        if (selected && selected.index !== undefined) { // if text is an existing label in items then get the value and set it
          this.set('value', selected.value);
        } else { // if text is a non-existing item then get the value and set it
          this.set('value', this.inputNode.value);
        }

        var newValue = this.get('value');
        if (oldValue !== newValue) {
          this._triggerChangeEvent('value', oldValue, newValue);
        }

        this.closeMenu(); // close the menu when Enter is hit. See g1393696
      }
    },

    _openComboBoxMenu: function (args) {
      // Highlight the pre-selected or currently selected value by applying the 'mwComboBoxSelectedMenuItem' class
      var selected = this._get('value') !== undefined ? this._getSelectedItemFromValue(this._get('value')) : undefined;

      if (selected !== undefined && this.get('menu').getChildren().length > 0) {
        this.get('menu').getChildren()[selected.index].classList.add('mwComboBoxSelectedMenuItem');
        // If re-opening ComboBox because of a filtering action due to user typing, do not re-focus to selected item.
        // Let the focus remain in the text box so that the user can continue typing/filtering.
        if (!args || !args.noFocus) {
          this.get('menu').getChildren()[selected.index].focus(); // Use focus() method here. see g1691551
        }
      }
      // if the drop down should be opened when not typing show all the menu items
      if (!args || !args.typing) {
        this.get('menu').getChildren().forEach(function (menuItem, i) {
          if (menuItem.style.display === 'none') {
            menuItem.style.display = '';
          }
        });
      }

      this.menu.domNode.style.minWidth = (this.domNode.getBoundingClientRect().width - 2) + 'px';
      var popupObj = popup.open({
        parent: this,
        popup: this.get('menu'),
        around: this.domNode,
        orient: this.menuOrientation,
        onClose: function () {
          if (!this._destroyed === true) {
            this.domNode.classList.remove('mwHasMenuOpened');
            this.domNode.classList.contains('mwHasMenuOpenedTop')
              ? this.domNode.classList.remove('mwHasMenuOpenedTop') : this.domNode.classList.remove('mwHasMenuOpenedBottom');
          }

          this._comboBoxMenuOpened = false;

          // Geck 1387318 => Popup.js does not handle resetting overflow property in IE
          if (this.menu && this.menu.domNode && this.menu.domNode.parentNode) {
            this.menu.domNode.parentNode.style.overflowX = 'visible';
            this.menu.domNode.parentNode.style.overflowY = 'visible';

            this.menu.domNode.parentElement.classList.remove('mwDropDownHasOpenedUpwards');
            this.menu.domNode.parentElement.classList.remove('mwDropDownHasOpenedDownwards');
            this.menu.domNode.parentElement.classList.remove('mwDropDownHasScrollbars');
            this.menu.domNode.parentElement.classList.remove('mwDropDownHasMaxHeight');
          }
        }.bind(this)
      });

      // g1990733 dijit/popup.js code on Chrome/Mac may get the height of menu items wrong
      // (too small) the first time the menu is opened (e.g. not accounting for taller
      // Japanese characters in the menu items).
      // Workaround is to adjust the menu height and add scrollbar in that case.
      // This avoids case where an upwards-opening menu could be restricted in height by the
      // top of the window, but appear without scrollbars and obscure the ComboBox itself.
      var menuParent = this.get('menu').domNode.parentElement;
      var menuParentPos = menuParent.getBoundingClientRect();
      var comboBoxPos = this.domNode.getBoundingClientRect();
      // If menu is obscuring the ComboBox, then shorten the height and turn on the scrollbar
      if (menuParentPos.top < comboBoxPos.top && menuParentPos.top + menuParentPos.height > comboBoxPos.top) {
        menuParent.style.height = (comboBoxPos.top - menuParentPos.top) + 'px';
        menuParent.style.overflowY = 'scroll';
      }

      this.domNode.classList.add('mwHasMenuOpened');
      // remove top or bottom border radius depending on where the menu opens. see g1764752
      // popupObj.corner return BL when the menu opens on top.
      // Also check for if popupObj is a valid object. See g1809489
      if (popupObj && popupObj.corner && popupObj.corner === 'BL') {
        this.domNode.classList.add('mwHasMenuOpenedTop');
        this.menu.domNode.parentElement.classList.add('mwDropDownHasOpenedUpwards');
      } else {
        this.domNode.classList.add('mwHasMenuOpenedBottom');
        this.menu.domNode.parentElement.classList.add('mwDropDownHasOpenedDownwards');
      }

      this._comboBoxMenuOpened = true;

      if (!this.menu.domNode.parentElement.classList.contains('mwComboBoxPopupParent')) {
        this.menu.domNode.parentElement.classList.add('mwComboBoxPopupParent');
      }

      // g1906115 dijit popup.js removes the popup menu border if the menu has scrollbars.
      var popupParentElt = this.menu.domNode.parentElement;
      if (popupParentElt) {
        popupParentElt.style.border = ''; // remove inline border attribute so proper CSS will be applied
        var hasVerticalScrollbars = popupParentElt.scrollHeight > popupParentElt.clientHeight;
        if (hasVerticalScrollbars) {
          // if vertical scrollbar appears, add classes to tweak the margin-top
          popupParentElt.classList.add('mwDropDownHasScrollbars');
          if (popupParentElt.clientHeight === this.get('maxHeight')) {
            popupParentElt.classList.add('mwDropDownHasMaxHeight');
          }
        }
      }
    },

    /*
     * This method handles the typing event that is fired
     * on the text field to search for menu items and filter
     * according to the value typed into the text field.
     * */

    _handleTextFieldTyping: function (e) {
      // Get the current content of the textfield
      var typedText = e.mwEventData.currentContent;

      var regexp = new RegExp(this._escapeRegExp(typedText), 'i');

      // Loop over each menu item and compare the text of menu item
      // with the current text in the textfield. If the typed text
      // matches with the menu item(s)' text, the domNode of that menu
      // item(s) has the default display property and all other unmatching
      // menu items are hidden.

      this.get('menu').getChildren().forEach(function (menuItem, i) {
        // If it is a separator, hide it and return
        if (this._isSeparator(menuItem)) {
          menuItem.style.display = 'none';
          return;
        }

        // get the text content of the menu item
        var menuItemText = menuItem.textContent;

        if (menuItemText.toLowerCase().indexOf(typedText.toLowerCase()) === 0) {
          if (typedText !== '' || regexp.test(menuItemText)) {
            // keep displaying the matched menu items
            menuItem.style.display = '';
          }
        } else {
          // hide the unmatched menu items
          menuItem.style.display = 'none';
        }
      }.bind(this));

      // When the state of the menu items are filtered, The code below makes
      // sure that two separators are not displayed next to each other without
      // having at least one menuItem between them.
      // This way, there will be no separators next to each other which otherwise
      // can appear as a bold line.
      var itemCount = 0;
      this.get('menu').getChildren().forEach(function (menuItem) {
        if (this._isSeparator(menuItem) && itemCount > 0) {
          menuItem.style.display = 'block';
          itemCount = 0;
        } else if (!this._isSeparator(menuItem) && menuItem.style.display !== 'none') {
          itemCount++;
        }
      }.bind(this));

      // calling the openMenu() method by sending the typing object argument

      // Open the ComboBox.
      // If it is already open, this call will close then re-open it to adjust for any new text filtering.
      // Since user is editing text, set the noFocus flag so that focus won't switch to the selected menu item.
      this._openComboBoxMenu({ typing: true, noFocus: true });
    },

    /*
     * This method is the listener for keydown event on a menu item.
     * It takes care of the cases where backspace key, left arrow and
     * down arrow keys are pressed in which case the focus should be
     * given to the focus node i.e. the text field.
     * */

    _handleMenuKeyDown: function (e) {
      // to prevent from triggering the back action of the browser to navigate back to previous visited page
      if (e.keyCode === keys.BACKSPACE) {
        e.preventDefault();
        focusUtil.focus(this._textField.focusNode);
      } else if ((e.keyCode === keys.ENTER || e.keyCode === keys.SPACE) && !this.get('disabled')) {
        on.emit(e.target, 'click', {
          bubbles: true,
          cancelable: true,
          mwEventData: {
            keyCode: e.keyCode
          },
          _dojo_click: true
        });
      } else if (e.keyCode === keys.ESCAPE) {
        this.closeMenu();
        // TODO: focus focus node
        focusUtil.focus(this.focusNode);
        e.stopPropagation();
        e.preventDefault();
      } else if (this.editable && e.keyCode !== keys.DOWN_ARROW && e.keyCode !== keys.UP_ARROW) {
        // For any other keys, put focus back on the text field. Typical use case is
        // when the user has opened the dropdown and traversed menu items via the mouse
        // or keyboard (possibly because some items were scrolled out of view). Now the
        // user starts typing -- in this case, automatically put focus back into the text
        // field for the user so that it will work (i.e. immediately starts filtering based
        // on newly typed keys).
        //
        // Exception - skip this for up/down arrow keys so that those can still be used
        // to traverse menu items.
        //
        // For this special case, note that _handleTextFieldKeyDown() is not triggered, but
        // none of that logic is needed for this path.

        focusUtil.focus(this._textField.focusNode);
      }
    },
    
    /*
     * This method is the listener for keyup event on the text field.
     * */
    _handleTextFieldKeyUp: function (e) {
        // If a keyup occurs without a keydown for ENTER or SPACE, ignore it. g2098412
        // Most likely a keydown occurred on a menu item, which dismissed the menu 
        // so that the keyup occurred on the text field.
        // In particular, prevent ENTER and SPACE keys from propagating up, which
        // could result in e.g. the default button of a Dialog being clicked.
        // Don't do this for every key, though. E.g. TAB'ing to an editable ComboBox
        // will result in a keyup without a keydown, but no need to suppress the keyup.
        if ((!this._gotTextFieldKeyDownForEnterOrSpace) && (e.keyCode === keys.ENTER || e.keyCode === keys.SPACE) && !this.get('disabled')) {
          e.stopPropagation();
          e.preventDefault();
        }
        this._gotTextFieldKeyDownForEnterOrSpace = false;
    },

    /*
     * This method handles the click event that occurs on a menu item.
     * The menu item that gets clicked becomes the selected value of the
     * combo box. The text of the menu item(label) is displayed as the value
     * of text field.
     * */

    _handleMenuClick: function (e) {
      if (this._isSeparator(e.target) || (!e.target.classList.contains('mwMenuItem') && !e.target.classList.contains('mwTextNode'))) {
        e.preventDefault();
        return;
      }

      // Find the item that was selected based on the click target
      var selectedItem = this._getItemForNode(e.target);
      // Determine the value of the corresponding item
      var selectedValue = selectedItem.value;
      var oldValue = this.get('value');
      this.set('value', selectedValue);

      if (oldValue !== selectedValue) {
        this._triggerChangeEvent('value', oldValue, selectedValue);
      }

      this.closeMenu();
    },

    /**
     * This function finds the item object listed in items property for the input item dom node.
     * @param node item dom node
     * @returns {*} the item object with label and value for the given item dom node.
     * @private
     */
    _getItemForNode: function (node) {
      var menu = this.get('menu');
      var items = this.get('items');

      // find the item property for the input dom node if it is a node for one of the combobox items
      var menuChildNodes = menu.getChildren();
      var item = null;
      for (var i = 0; i < menuChildNodes.length; i++) {
        if (menuChildNodes[i].contains(node)) {
          item = items[i];
          break;
        }
      }
      return item;
    },

    _removeSelectedMenuItemColor: function () {
      // If the user has already pre-selected a value or made a selection manually
      // on the combo box, remove the class that highlights the previously selected
      // value in the combo box.
      
      // Don't try to change the DOM if the ComboBox is being destroyed.
      if (this._beingDestroyed) {
          return;
      }
      var selected = this._get('value') !== undefined ? this._getSelectedItemFromValue(this._get('value')) : undefined;
      if (selected !== undefined && this.get('menu').getChildren().length > 0) {
        this.get('menu').getChildren()[selected.index].classList.remove('mwComboBoxSelectedMenuItem');
      }
    },

    _getParentPopup: function (node) {
      while (node) {
        if (node.classList && node.classList.contains('dijitPopup')) {
          return node;
        }
        node = node.parentNode;
      }
      return null;
    },

    resize: function () {
      /*

                               +--->calc() is on TextFieldContainer
                               |
                            +--------------------------------------+
                            |XX+XXXXXXXXXXXXXXXXXXXXXXXX|XXXXXXXXXX|
                            |X                         X|X        X|
                            |X   TextField is 100%     X|X 22 px  X|
                            |X                         X|X   +    X|
                            |XXXXXXXXXXXXXXXXXXXXXXXXXXX|XXXX|XXXXX|
                            +--------------------------------------+
                                                             |
                                                             |
                                                             v
                                                      arrow node is fixed
      */

      var arrowNodeWidth = 22; // 22 px value is the fixed size of arrowNode
      this._textField.domNode.parentNode.style.width = 'calc(100%' + ' - ' + arrowNodeWidth + 'px)';
      this._textField.set('width', '100%');
    },

    focus: function () {
      if (!this.disabled && this.focusNode.focus) {
        try {
          setTimeout(function () {
            focusUtil.focus(this.focusNode);
          }.bind(this), 0);
        } catch (e) {
        }
      }
    },

    // TODO: reuse maxHeightMixin after moving it to mw-form/mixins/
    _setMaxHeightAttr: function (value) {
      if (typeof value !== 'number') {
        throw new Error("'MaxHeight' property expects a Number!");
      }
      this.menu.domNode.style.maxHeight = value + 'px';
      this._set('maxHeight', value);
    },

    _setValueAttr: function (value) {
      // If a pre-selected value is passed in as argument and if it is
      // equal to any of the item's value present in the items array, that
      // value becomes the selected value of the combo box in both editable
      // and non-editable cases.

      var selected = this._getSelectedItemFromValue(value);

      if ((typeof value === 'number' ? value.toString() : value) && selected && selected.index !== undefined) {
        var selectedLabel = selected.label;
        this._textField.set('value', selectedLabel);
        this._isTextEmpty = true;
        this._removeSelectedMenuItemColor();
        if (this.get('menu').getChildren().length > 0 && selected.index !== undefined) {
          this.get('menu').getChildren()[selected.index].classList.add('mwComboBoxSelectedMenuItem');
        }
      } else if ((typeof value === 'number' ? value.toString() : value) && !selected) {
        if (this.get('editable')) {
          this._removeSelectedMenuItemColor();
          this._textField.set('value', value);
          this._isTextEmpty = false;
        } else {
          if (!this.get('items') || this.get('items').length === 0) { // see g1397593
            this._pendingValue = value;
            return;
          } else {
            throw new Error('Value must match an existing item for non-editable combo box');
          }
        }
      } else if (value === '') {
        this._textField.set('value', '');

        if (this._get('value') !== undefined) {
          this._removeSelectedMenuItemColor();
          this._isTextEmpty = true;
        }

        if (this.get('text') !== '') {
          this._isTextEmpty = false;
        }
      }

      if (this._isTextEmpty === true) {
        this.set('text', '');
      } else {
        this.set('text', value);
      }

      var oldValue = this.get('value');
      this._set('value', value);
    },

    _getValueAttr: function () {
      return this._get('value');
    },

    _setItemsAttr: function (items) {
      // Note: setting the items property is a programmatic behavior, not a user interaction, behavior,
      // so the change event should not fire.

      // Save current value/label to set ComboBox to that item if it exists in the new items
      var oldValue = this.get('value');
      var oldLabel = null;
      var oldSelectedItem = this._getSelectedItemFromValue(oldValue);
      if (oldSelectedItem) {
        oldLabel = oldSelectedItem.label;
      }

      if (items && items.length > 0) {
        this.set('value', '');
        this._initMenuItems(items);
        this._set('items', items);

        // If old value exists in new items, and labels match, too, then select it
        var newSelectedItem = this._getSelectedItemFromValue(oldValue);
        if (newSelectedItem && oldLabel === newSelectedItem.label) {
          this.set('value', oldValue);
        }
      } else {
        this.set('value', '');
        // clear the menuitems and the labelValue and valueLabel maps
        this._destroyMenuItems();
        this._set('items', items);
      }

      if (this.get('editable') === false && this._pendingValue != null) {
        this.set('value', this._pendingValue);
        this._pendingValue = null;
      }

      if (this._comboBoxMenuOpened) {
        // setting combobox items while the combobox is open can lead to incorrect computation of the combobox height
        // To rectify this issue, in such a scenario close the combobox and open it again. (refer geck: g2017474)
        this.closeMenu();
        this._openComboBoxMenu();
      }
    },

    /*
     * The _initItems is called from the _setItemsAttr method to create menu items and add them to the
     * menu. After creating the menu items each menu item is assigned Click and Key Down event listeners.
     *
     * The method also constructs the "labelValue" and "valueLabel" maps while creating the menu items.
     * */
    _initMenuItems: function (items) {
      // If there are menu items already existing, they will need to be removed
      // from the menu. Also the _labelValue and _valueLabel maps need to be
      // reset to their initial values. The reset part is important because
      // this will ensure news items do not get added to the existing list og
      // maps which would be undesirable.
      if (this.get('menu').getChildren().length > 0) {
        this._destroyMenuItems();
      }

      // Loop over each item from the items array to create a new menu item
      // by using the label of each item as the text for each menu item.
      // The newly created menu item is added to the menu and event listeners
      // are attached to each menu item that listen on click and keydown events.

      items.forEach(function (item, i) {
        // each menu item would have a parent i.e. DOM structure would look like
        //
        //          <div class="mwWidget mwDefaultVisualFamily mwTextMixin mwSharedMenuItem mwMenuItem">
        //               <div class="mwTextNode">Label text content</div>
        //          </div>
        // This is done to keep the styling and tests intact from the MenuItem widgets

        // create the menuItemParent
        var menuItemParent = document.createElement('div');

        if (item.type && item.type === 'separator') {
          menuItemParent.setAttribute('data-refuse-key-nav', true);
          menuItemParent.setAttribute('data-menu-item-type', 'separator');
          menuItemParent.classList.add('mwMenuSeparator');
          this.get('menu').menuItemsNode.appendChild(menuItemParent);
        } else {
          menuItemParent.setAttribute('tabIndex', '0');
          ['mwDefaultVisualFamily', 'mwTextMixin', 'mwTextMixin', 'mwWidget', 'mwSharedMenuItem', 'mwMenuItem'].forEach(function (c) {
            menuItemParent.classList.add(c);
          });

          // create the menuitem
          var menuItem = document.createElement('div');
          menuItem.textContent = item.label;
          menuItem.classList.add('mwTextNode');

          // append the menuItem to it's parent
          menuItemParent.appendChild(menuItem);
          // append the menuItemParent to menu's dom node
          this.get('menu').menuItemsNode.appendChild(menuItemParent);

          menuItemParent.addEventListener('mouseover', this._handleMenuItemMouseEnter.bind(this));
        }
      }, this);
    },

    _getItemsAttr: function () {
      return this._get('items');
    },

    /*
     * Overriding the setter from EditableMixin when editable property is set
     * on the widget.
     * If the widget is set to be editable the focusNode of the
     * widget is set to the textfield's focusNode. The textfield is made editable
     * and enabled. menuNode is assigned to the arrownode.
     * If the widget is set to be non-editable the focusNode of the
     * widget is set to the widget's domNode. The textfield is made non-editable
     * and disabled. menuNode is assigned to the domNode.
     * */

    _setEditableAttr: function (value) {
      // Note: Removed this.inherited call as it was redundant and also to avoid recursive calls
      if (value) {
        this.domNode.classList.add('mwEditableComboBox');
        this.domNode.classList.remove('mwNonEditable');
        this.focusNode = this._textField.focusNode;
        this._toggleTextField(true);

        // Only one element should have tabIndex (or none, if disabled)
        if (this.get('disabled')) {
          this._textField.focusNode.removeAttribute('tabIndex');
        } else {
          this._textField.focusNode.setAttribute('tabIndex', '0'); // see g1438764
        }
        this.domNode.removeAttribute('tabIndex');

        // before switching menuNode to the arrowNode, remove any listener on it
        this._removeMenuNodeMouseDownHandler();

        this.menuNode = this.arrowNode;

        // re-attach listener to new menuNode (just the arrowNode)
        this._addMenuNodeMouseDownHandler();

        this._set('editable', true);
      } else {
        this.domNode.classList.add('mwNonEditable');
        this.domNode.classList.remove('mwEditableComboBox');
        this.focusNode = this.domNode;
        this._toggleTextField(false);

        // Only one element should have tabIndex (or none, if disabled)
        this._textField.focusNode.removeAttribute('tabIndex');
        if (this.get('disabled')) {
          this.domNode.removeAttribute('tabIndex');
        } else {
          this.domNode.setAttribute('tabIndex', '0');
        }

        // before switching menuNode to the domNode, remove any listener on it
        this._removeMenuNodeMouseDownHandler();

        this.menuNode = this.domNode;

        // re-attach listener to new menuNode
        this._addMenuNodeMouseDownHandler();

        this._set('editable', false);
      }
    },

    _removeMenuNodeMouseDownHandler: function () {
      if (this._menuNodeMouseDownHandler) {
        this.menuNode.removeEventListener('mousedown', this._menuNodeMouseDownHandler);
        this._menuNodeMouseDownHandler = null;
      }
    },

    _addMenuNodeMouseDownHandler: function () {
      if (this.menuNode && this._menuNodeMouseDownHandler === null) {
        this._menuNodeMouseDownHandler = this._handleArrowNodeMouseDown.bind(this);
        this.menuNode.addEventListener('mousedown', this._menuNodeMouseDownHandler);
      }
    },

    _setTextAttr: function (value) {
      // The 'text' property reflects text that the user has typed that is not in the list of items.
      // While 'text' being empty means that the user has chosen something from the list of items
      // which is reflected in the 'value' property.
      // Note: 'value' can never be something other than one of the items in the list.

      if (this._isTextEmpty === false || ((this.get('value') === '' || this.get('value') === undefined) && value !== '')) {
        if (this.get('editable') && this._getSelectedItemFromValue(value) === undefined) {
          this._set('text', value);
          this._isTextEmpty = false;
        } else {
          this._isTextEmpty = true;
          this._set('text', '');
        }
        this._textField.set('value', value);
      } else {
        this._set('text', '');
      }
    },

    _getTextAttr: function (value) {
      return this._get('text');
    },

    /*
     * This method toggles the editable and disabled properties of the textfield
     * widget to be opposites of the boolean value passed in as required by the
     * editable attribute setter in this widget.
     * */
    _toggleTextField: function (value) {
      this._textField.set('editable', value);
      // disable the textfield if the widget is disabled too. See g1668144
      this.get('disabled') === true ? this._textField.set('disabled', true) : this._textField.set('disabled', !value);
    },

    /*
     * This method sets the menuOrientation property which is used when combo box's popup
     * is opened. The menuOrientation property determines where the popup should open.
     * By default the orientation values are set to "vertical". Authors can set orientation
     * from the values allowed in ORIENTATION_VALUES.
     * menuOrientation property is configurable due to G1467254.
     * TODO: see if MenuMixin can be brought back in to the combo box
     * */
    _setMenuOrientationAttr: function (/* String */ orientation) {
      if ((typeof orientation !== 'string') || (this.ORIENTATION_VALUES.hasOwnProperty(orientation) === -1)) {
        throw new Error("'menuOrientation' property expects one of these values: " + Object.keys(this.ORIENTATION_VALUES));
      }
      this._set('menuOrientation', this.ORIENTATION_VALUES[orientation]);
    },

    _setWidthAttr: function (value) {
      this.inherited(arguments);

      if (this._started !== undefined || this._started === true) {
        this.resize();
      }
    },

    _setHeightAttr: function (value) {
      this.inherited(arguments);
      this._textField.set('height', value);
    },

    _setPlaceholderAttr: function (value) {
      this._textField.set('placeholder', value);
      this._set('placeholder', value);
    },

    _getPlaceholderAttr: function () {
      return this._textField.get('placeholder');
    },

    _setDescriptionAttr: function (value) {
      this.inherited(arguments);
      this._textField.set('description', value);
    },

    _destroyMenuItems: function () {
      while (this.get('menu').menuItemsNode.firstChild) {
        // remove the mouseover listener which was assigned to each menuItemParent in initMenuitems method during menu item creating
        this.get('menu').menuItemsNode.firstChild.removeEventListener('mouseover', this._handleMenuItemMouseEnter.bind(this));
        this.get('menu').menuItemsNode.removeChild(this.get('menu').menuItemsNode.firstChild);
      }
    },

    _escapeRegExp: function (str) {
      // Using the escape regular expression method from MDN
      // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Using_special_characters
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },

    _getSelectedItemFromLabel: function (label) {
      var selectedItem = {};

      if (this.get('items') && this.get('items').length > 0) {
        for (var i = 0; i < this.get('items').length; i++) {
          var item = this.get('items')[i];
          if (item.label !== undefined && item.label === label) {
            selectedItem.label = item.label;
            selectedItem.value = item.value;
            selectedItem.index = i;
            break;
          }
        }
      }

      return selectedItem.index !== undefined ? selectedItem : undefined;
    },

    _getSelectedItemFromValue: function (value) {
      var selectedItem = {};

      if (this.get('items') && this.get('items').length > 0) {
        for (var i = 0; i < this.get('items').length; i++) {
          var item = this.get('items')[i];
          // check for object equality also. see g1600969
          if (item.value !== undefined &&
                ((item.value === value) ||
                    (typeof item.value === 'object' && JSON.stringify(item.value) === JSON.stringify(value)))) {
            selectedItem.label = item.label;
            selectedItem.value = item.value;
            selectedItem.index = i;
            break;
          }
        }
      }

      return selectedItem.index !== undefined ? selectedItem : undefined;
    },

    _isSeparator: function (node) {
      return node && node.getAttribute('data-menu-item-type') && node.getAttribute('data-menu-item-type') === 'separator';
    },

    _isKeyboardNav: function (node) {
      return node.style.display !== 'none' && !this._isSeparator(node);
    },

    /**
     * Following are QE utility methods for callback testing
     * */
    _qeSelectItemByLabel: function (/* string */ _label) {
      var valueToSet = this._getSelectedItemFromLabel(_label).value; // get the value to set
      this.set('value', valueToSet);
    },

    _qeSelectItemByValue: function (/* string */ _value) {
      var valueToSet = this._getSelectedItemFromValue(_value).value; // get the value to set
      this.set('value', valueToSet);
    },

    _qeSelectItemByIndex: function (/* int */ index) {
      var valueToSet = this.get('items')[index].value; // get the value to set from items object
      this.set('value', valueToSet);
    }
  });
});
